//rotinas padrão
export const podeIncluir = () => {
    const permissao = JSON.parse(localStorage.getItem('incluir')) !== false;
    if (!permissao) return false;
    return true;
};
export const podeEditar = () => {
    const permissao = JSON.parse(localStorage.getItem('editar')) !== false;
    if (!permissao) return false;
    return true;
};
export const podeImprimir = () => {
    const permissao = JSON.parse(localStorage.getItem('imprimir')) !== false;

    if (!permissao) return false;

    return true;
};
export const podeCancelar = () => {
    const permissao = JSON.parse(localStorage.getItem('cancelar')) !== false;
    if (!permissao) return false;
    return true;
};
export const podeTransformar = () => {
    const permissao = JSON.parse(localStorage.getItem('transformar')) !== false;
    if (!permissao) return false;
    return true;
};

//rotinas para o movimento
export const podeEditarMovimento = (row) => {
    const permissao = JSON.parse(localStorage.getItem('editar')) !== false;

    if (!permissao) return false;
    if (row.original.transformado) return false;

    return true;
};
export const podeImprimirMovimento = (row) => {
    const permissao = JSON.parse(localStorage.getItem('imprimir')) !== false;

    if (!permissao) return false;
    //coloque aqui regras proprias para bloqueio de impressão de movimento
    return true;
};
export const podeCancelarMovimento = (row) => {
    const permissao = JSON.parse(localStorage.getItem('cancelar')) !== false;

    if (!permissao) return false;
    if (row.original.transformado) return false;

    return !row.original?.Lancamentos?.some((lancamento) =>
        lancamento.lancamentoBaixas?.some((baixa) => baixa.estornado === false)
    );
};
export const podeEditarItem = () => {
    const permissao = JSON.parse(localStorage.getItem('editarItem')) !== false;

    if (!permissao) return false;

    return true;
};
export const podeImprimirItem = () => {
    const permissao = JSON.parse(localStorage.getItem('imprimirItem')) !== false;

    if (!permissao) return false;

    return true;
};
export const podeCancelarItem = () => {
    const permissao = JSON.parse(localStorage.getItem('cancelarItem')) !== false;

    if (!permissao) return false;

    return true;
};
// financeiro
export const podeBaixar = () => {
    const permissao = JSON.parse(localStorage.getItem('baixar')) !== false;

    if (!permissao) return false;

    return true;
};
export const podeCancelarBaixa = () => {
    const permissao = JSON.parse(localStorage.getItem('baixar')) !== false;

    if (!permissao) return false;

    return true;
};
// relatórios
export const podeImprimirAnalitico = () => {
    const permissao = JSON.parse(localStorage.getItem('impAnalitico')) !== false;

    if (!permissao) return false;

    return true;
};
export const podeImprimirGerencia = () => {
    const permissao = JSON.parse(localStorage.getItem('impGerencia')) !== false;

    if (!permissao) return false;

    return true;
};
export const podeImprimirSintetico = () => {
    const permissao = JSON.parse(localStorage.getItem('impSintetico')) !== false;

    if (!permissao) return false;

    return true;
};

//caixa logistica
export const podeConferir = () => {
    const permissao = JSON.parse(localStorage.getItem('conferir')) !== false;

    if (!permissao) return false;

    return true;
};

// Função auxiliar para aplicar filtros e ordenação
export const applyLocalFiltersAndSorting = (data, globalFilter) => {
    // Aplica os filtros e ordenações locais
    let result = data;

    // Exemplo de aplicação de filtro global
    if (globalFilter) {
        result = result.filter((item) => item.name.includes(globalFilter));
    }

    // Aplicar ordenação, filtro de colunas, etc., conforme necessário
    // result.sort(...), result.filter(...), etc.

    return result;
};

/**
 * Prepara array para select/grid: [{label, value}]
 * - Aceita array de strings OU array de objetos
 * - Permite escolher quais campos usar (labelKey/valueKey) ou funções (getLabel/getValue)
 * - const mappedResult = prepareOptions(result); // usa descricao por padrão
 * const opts = prepareOptions(result, {  getLabel: (i) => `${i.codigo} - ${i.descricao}`,  getValue: (i) => i.codigo,});
 * const opts = [{ label: "Todos", value: "" }, ...prepareOptions(result)]; // todos os campos
 */
export const prepareOptions = (
    arr,
    {
        labelKey = 'descricao',
        valueKey = labelKey,
        getLabel,
        getValue,
        trim = true,
        unique = true,
        sort = true,
        locale = 'pt-BR',
    } = {}
) => {
    const list = Array.isArray(arr) ? arr : [];

    let out = list
        .map((item) => {
            // string
            if (typeof item === 'string') {
                const v = trim ? item.trim() : item;
                return { label: v, value: v };
            }

            // objeto
            const rawLabel = getLabel ? getLabel(item) : item?.[labelKey];
            const rawValue = getValue ? getValue(item) : item?.[valueKey];

            const label = trim ? String(rawLabel ?? '').trim() : String(rawLabel ?? '');
            const value = trim ? String(rawValue ?? '').trim() : String(rawValue ?? '');

            return { label, value };
        })
        .filter((opt) => opt?.label); // remove vazios/undefined

    if (unique) {
        const seen = new Set();
        out = out.filter((o) => {
            const k = `${o.value}__${o.label}`;
            if (seen.has(k)) return false;
            seen.add(k);
            return true;
        });
    }

    if (sort) {
        out.sort((a, b) => String(a.label).localeCompare(String(b.label), locale));
    }

    return out;
};
